import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoResponsablesItemComponent {
  data
  idProyecto
  guardando
  longitud
  primero
  ultimo
  onChange
  onDelete
  editando = false

  mover(valor) {
    this.data.valor = valor
    this.onChange({$event: {detail: this.data}})
  }

  cambiarRequerido() {
    if (this.data.requerido && this.longitud === 1) return

    this.data.requerido = !this.data.requerido
    this.data.requeridoValidar = false
    this.onChange({$event: {detail: this.data}})
  }

  requeridoNominas() {
    this.data.nominas = !this.data.nominas
    this.onChange({$event: {detail: this.data}})
  }

  requeridoFinanzas() {
    this.data.finanzas = !this.data.finanzas
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('viaticosConfiguracionProyectoResponsablesItem', {
  controller: ViaticosConfiguracionProyectoResponsablesItemComponent,
  template,
  bindings: {
    data: '<',
    idProyecto: '<',
    longitud: '<',
    guardando: '<',
    primero: '<',
    ultimo: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/item/component.js